<template>
  <div class="execution-followup">
    <v-card class="ma-sm-3" outlined>
      <tab-header
        :esv="esv"
        :readonly="readonly"
        :lockLoading="lockLoading"
        action="ESVSituation"
        :isConfirmingTabChange="isConfirmingTabChange"
        @edit="$emit('edit')"
      >
        <template #secondary-actions>
            <v-btn outlined small @click="routeBackToList"  class="mr-2">
              <v-icon left>mdi-arrow-left</v-icon>Back to list
            </v-btn>
          <v-btn outlined small to="/esvsituations">
            <v-icon left>mdi-arrow-left</v-icon>
            Go to overview ESV situations
          </v-btn>
        </template>
      </tab-header>

      <v-card outlined>
        <v-card-text class="pa-2">
          <v-row no-gutters class="ma-0">
            <v-col
              cols="12"
              sm="4"
              :class="$vuetify.breakpoint.smAndUp ? 'pr-1' : 'pb-2'"
            >
              <v-autocomplete v-if="!readonly"
                v-model="situation.userId"
                hide-details="auto"
                :items="peopleInCharge"
                label="Person in charge"
                outlined
                dense
                clearable
              ></v-autocomplete>
              <c-text-field v-else
                  :value="(() => { var personInCharge = peopleInCharge.filter(p => p.value === situation.userId)[0]; if (personInCharge) return personInCharge.text})()"
                  label="Person in charge"
                  readonly
                >
                </c-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="4"
              :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
            >
              <v-autocomplete v-if="!readonly"
                v-model="situation.topic"
                hide-details="auto"
                :items="topics"
                label="Topic"
                outlined
                dense
                clearable
              ></v-autocomplete>
              <c-text-field v-else
                  :value="situation.topic"
                  label="Topic"
                  readonly
                >
                </c-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="4"
              :class="$vuetify.breakpoint.smAndUp ? 'pl-1' : 'pb-2'"
            >
              <!-- <DatePicker v-model="situation.targetDate" label="Target Date"></DatePicker> -->
              <date-picker
                label="Target Date"
                v-model="situation.targetDateTime"
                @input="(value) => (situation.targetDateTime = value)"
                :readonly="readonly"
              ></date-picker>
              <!-- <date-picker label="Target Date" v-model="situation.targetDate" @input="(value) => situation.targetDate = value" :readonly="readonly"></date-picker> -->
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card flat>
        <v-card-text v-if="isFieldVisible(DocumentFields.PreparationSteps)" class="pa-2 pt-0">
          <!-- <v-container class="pa-0"> -->
          <v-row class="ma-0 mt-2">
            <v-col cols="1" class="d-flex align-center">
              <v-divider></v-divider>
            </v-col>
            <v-col class="d-flex align-center">
              <h3 class="pr-6">Preparation steps</h3>
              <v-divider></v-divider>
            </v-col>
          </v-row>
          <!-- Header -->
          <v-row no-gutters class="mt-2">
            <v-col
              cols="12"
              sm="2"
              :class="$vuetify.breakpoint.smAndUp ? 'pr-1' : 'pb-2'"
            >
              Step
            </v-col>
            <v-col
              cols="12"
              sm="2"
              :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
            >
              Status
            </v-col>
            <v-col
              cols="12"
              sm="2"
              :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
            >
              Date
            </v-col>
            <v-col
              cols="12"
              sm="6"
              :class="$vuetify.breakpoint.smAndUp ? 'pl-1' : 'pb-2'"
            >
              Remark
            </v-col>
          </v-row>

          <!-- SV -->
          <v-row no-gutters class="mt-2">
            <v-col
              cols="12"
              sm="2"
              :class="
                $vuetify.breakpoint.smAndUp
                  ? 'd-flex align-center pr-1'
                  : 'pb-2'
              "
            >
              SV
            </v-col>
            <v-col
              cols="12"
              sm="2"
              :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
            >
              <c-select v-model="situation.sv" :readonly="readonly" 
                  :items="statusses" :background-color="background(situation.sv)" 
                  :label="$vuetify.breakpoint.smAndUp ? '' : 'Status'">
              </c-select>
            </v-col>
            <v-col
              cols="12"
              sm="2"
              :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
            >
              <v-text-field
                hide-details="auto"
                :label="$vuetify.breakpoint.smAndUp ? '' : 'Date'"
                v-model="situation.changeDateSv"
                dense
                outlined
                readonly
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              :class="$vuetify.breakpoint.smAndUp ? 'pl-1' : 'pb-2'"
            >
              <v-text-field
                hide-details="auto"
                :label="$vuetify.breakpoint.smAndUp ? '' : 'Remark'"
                v-model="situation.svRemark"
                outlined
                dense
                :readonly="readonly"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- Scope -->
          <v-row no-gutters class="mt-2">
            <v-col
              cols="12"
              sm="2"
              :class="
                $vuetify.breakpoint.smAndUp
                  ? 'd-flex align-center pr-1'
                  : 'pb-2'
              "
            >
              Scope
            </v-col>
            <v-col
              cols="12"
              sm="2"
              :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
            >
              <c-select v-model="situation.scope" :readonly="readonly" 
                  :items="statusses" :background-color="background(situation.scope)" 
                  :label="$vuetify.breakpoint.smAndUp ? '' : 'Status'">
              </c-select>
            </v-col>
            <v-col
              cols="12"
              sm="2"
              :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
            >
              <v-text-field
                hide-details="auto"
                :label="$vuetify.breakpoint.smAndUp ? '' : 'Date'"
                v-model="situation.changeDateScope"
                dense
                outlined
                readonly
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              :class="$vuetify.breakpoint.smAndUp ? 'pl-1' : 'pb-2'"
            >
              <v-text-field
                hide-details="auto"
                :label="$vuetify.breakpoint.smAndUp ? '' : 'Remark'"
                v-model="situation.scopeRemark"
                outlined
                dense
                :readonly="readonly"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- WI -->
          <v-row no-gutters class="mt-2">
            <v-col
              cols="12"
              sm="2"
              :class="
                $vuetify.breakpoint.smAndUp
                  ? 'd-flex align-center pr-1'
                  : 'pb-2'
              "
            >
              WI
            </v-col>
            <v-col
              cols="12"
              sm="2"
              :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
            >
              <c-select v-model="situation.wi" :readonly="readonly" 
                  :items="statusses" :background-color="background(situation.wi)" 
                  :label="$vuetify.breakpoint.smAndUp ? '' : 'Status'">
              </c-select>
            </v-col>
            <v-col
              cols="12"
              sm="2"
              :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
            >
              <v-text-field
                hide-details="auto"
                :label="$vuetify.breakpoint.smAndUp ? '' : 'Date'"
                v-model="situation.changeDateWi"
                dense
                outlined
                readonly
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              :class="$vuetify.breakpoint.smAndUp ? 'pl-1' : 'pb-2'"
            >
              <v-text-field
                hide-details="auto"
                :label="$vuetify.breakpoint.smAndUp ? '' : 'Remark'"
                v-model="situation.wiRemark"
                outlined
                dense
                :readonly="readonly"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- Rework SPP -->
          <v-row no-gutters class="mt-2">
            <v-col
              cols="12"
              sm="2"
              :class="
                $vuetify.breakpoint.smAndUp
                  ? 'd-flex align-center pr-1'
                  : 'pb-2'
              "
            >
              Rework SPP
            </v-col>
            <v-col
              cols="12"
              sm="2"
              :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
            >
              <c-select v-model="situation.reworkSpp" :readonly="readonly" 
                  :items="statusses" :background-color="background(situation.reworkSpp)" 
                  :label="$vuetify.breakpoint.smAndUp ? '' : 'Status'">
              </c-select>
            </v-col>
            <v-col
              cols="12"
              sm="2"
              :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
            >
              <v-text-field
                hide-details="auto"
                :label="$vuetify.breakpoint.smAndUp ? '' : 'Date'"
                v-model="situation.changeDateReworkSpp"
                dense
                outlined
                readonly
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              :class="$vuetify.breakpoint.smAndUp ? 'pl-1' : 'pb-2'"
            >
              <v-text-field
                hide-details="auto"
                :label="$vuetify.breakpoint.smAndUp ? '' : 'Remark'"
                v-model="situation.reworkSppRemark"
                outlined
                dense
                :readonly="readonly"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- Rework Units -->
          <v-row no-gutters class="mt-2">
            <v-col
              cols="12"
              sm="2"
              :class="
                $vuetify.breakpoint.smAndUp
                  ? 'd-flex align-center pr-1'
                  : 'pb-2'
              "
            >
              Rework Units
            </v-col>
            <v-col
              cols="12"
              sm="2"
              :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
            >
              <c-select v-model="situation.reworkUnits" :readonly="readonly" 
                  :items="statusses" :background-color="background(situation.reworkUnits)" 
                  :label="$vuetify.breakpoint.smAndUp ? '' : 'Status'">
              </c-select>
            </v-col>
            <v-col
              cols="12"
              sm="2"
              :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
            >
              <v-text-field
                hide-details="auto"
                :label="$vuetify.breakpoint.smAndUp ? '' : 'Date'"
                v-model="situation.changeDateReworkUnits"
                dense
                outlined
                readonly
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              :class="$vuetify.breakpoint.smAndUp ? 'pl-1' : 'pb-2'"
            >
              <v-text-field
                hide-details="auto"
                :label="$vuetify.breakpoint.smAndUp ? '' : 'Remark'"
                v-model="situation.reworkUnitsRemark"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- Service Cost (WI-0365) -->
          <v-row no-gutters class="mt-2">
            <v-col
              cols="12"
              sm="2"
              :class="
                $vuetify.breakpoint.smAndUp
                  ? 'd-flex align-center pr-1'
                  : 'pb-2'
              "
            >
              Service Cost (WI-0365)
            </v-col>
            <v-col
              cols="12"
              sm="2"
              :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
            >
              <c-select v-model="situation.serviceCost" :readonly="readonly" 
                  :items="statusses" :background-color="background(situation.serviceCost)" 
                  :label="$vuetify.breakpoint.smAndUp ? '' : 'Status'">
              </c-select>
            </v-col>
            <v-col
              cols="12"
              sm="2"
              :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
            >
              <v-text-field
                hide-details="auto"
                :label="$vuetify.breakpoint.smAndUp ? '' : 'Date'"
                v-model="situation.changeDateServiceCost"
                dense
                outlined
                readonly
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              :class="$vuetify.breakpoint.smAndUp ? 'pl-1' : 'pb-2'"
            >
              <v-text-field
                hide-details="auto"
                :label="$vuetify.breakpoint.smAndUp ? '' : 'Remark'"
                v-model="situation.serviceCostRemark"
                outlined
                dense
                :readonly="readonly"
                placeholder="If service cost can not easily be understood from guideline WI-0365 add service cost calculation sheet to the internal attachments in the tab Internal Documents"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- Part Creation (WI-0169) -->
          <v-row no-gutters class="mt-2">
            <v-col
              cols="12"
              sm="2"
              :class="
                $vuetify.breakpoint.smAndUp
                  ? 'd-flex align-center pr-1'
                  : 'pb-2'
              "
            >
              Part Creation (WI-0169)
            </v-col>
            <v-col
              cols="12"
              sm="2"
              :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
            >
              <c-select v-model="situation.partCreation" :readonly="readonly" 
                  :items="statusses" :background-color="background(situation.partCreation)" 
                  :label="$vuetify.breakpoint.smAndUp ? '' : 'Status'">
              </c-select>
            </v-col>
            <v-col
              cols="12"
              sm="2"
              :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
            >
              <v-text-field
                hide-details="auto"
                :label="$vuetify.breakpoint.smAndUp ? '' : 'Date'"
                v-model="situation.changeDatePartCreation"
                dense
                outlined
                readonly
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              :class="$vuetify.breakpoint.smAndUp ? 'pl-1' : 'pb-2'"
            >
              <v-text-field
                hide-details="auto"
                :label="$vuetify.breakpoint.smAndUp ? '' : 'Remark'"
                v-model="situation.partCreationRemark"
                outlined
                dense
                :readonly="readonly"
                placeholder="The parts creation files should be added tot the internal attachments in the tab Internal Documents"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- Part Availability (WI-0169) -->
          <v-row no-gutters class="mt-2">
            <v-col
              cols="12"
              sm="2"
              :class="
                $vuetify.breakpoint.smAndUp
                  ? 'd-flex align-center pr-1'
                  : 'pb-2'
              "
            >
              Part Availability (WI-0169)
            </v-col>
            <v-col
              cols="12"
              sm="2"
              :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
            >
              <c-select v-model="situation.partAvailability" :readonly="readonly" 
                  :items="statusses" :background-color="background(situation.partAvailability)" 
                  :label="$vuetify.breakpoint.smAndUp ? '' : 'Status'">
              </c-select>
            </v-col>
            <v-col
              cols="12"
              sm="2"
              :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
            >
              <v-text-field
                hide-details="auto"
                :label="$vuetify.breakpoint.smAndUp ? '' : 'Date'"
                v-model="situation.changeDatePartAvailability"
                dense
                outlined
                readonly
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              :class="$vuetify.breakpoint.smAndUp ? 'pl-1' : 'pb-2'"
            >
              <v-text-field
                hide-details="auto"
                :label="$vuetify.breakpoint.smAndUp ? '' : 'Remark'"
                v-model="situation.partAvailabilityRemark"
                outlined
                dense
                :readonly="readonly"
                placeholder="If normal spare parts are used, check the need to order additional parts"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- Software Availability -->
          <v-row no-gutters class="mt-2">
            <v-col
              cols="12"
              sm="2"
              :class="
                $vuetify.breakpoint.smAndUp
                  ? 'd-flex align-center pr-1'
                  : 'pb-2'
              "
            >
              Software Availability
            </v-col>
            <v-col
              cols="12"
              sm="2"
              :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
            >
              <c-select v-model="situation.softwareAvailability" :readonly="readonly" 
                  :items="statusses" :background-color="background(situation.softwareAvailability)" 
                  :label="$vuetify.breakpoint.smAndUp ? '' : 'Status'">
              </c-select>
            </v-col>
            <v-col
              cols="12"
              sm="2"
              :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
            >
              <v-text-field
                hide-details="auto"
                :label="$vuetify.breakpoint.smAndUp ? '' : 'Date'"
                v-model="situation.changeDateSoftwareAvailability"
                dense
                outlined
                readonly
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              :class="$vuetify.breakpoint.smAndUp ? 'pl-1' : 'pb-2'"
            >
              <v-text-field
                hide-details="auto"
                :label="$vuetify.breakpoint.smAndUp ? '' : 'Remark'"
                v-model="situation.softwareAvailabilityRemark"
                outlined
                dense
                :readonly="readonly"
                placeholder="If applicable, include the new unit software to the updater tool (only set status to 'final' if updater tool is OK)"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- Claim Procedure -->
          <v-row no-gutters class="mt-2">
            <v-col
              cols="12"
              sm="2"
              :class="
                $vuetify.breakpoint.smAndUp
                  ? 'd-flex align-center pr-1'
                  : 'pb-2'
              "
            >
              Claim Procedure
            </v-col>
            <v-col
              cols="12"
              sm="2"
              :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
            >
              <c-select v-model="situation.claimProcedure" :readonly="readonly" 
                  :items="statusses" :background-color="background(situation.claimProcedure)" 
                  :label="$vuetify.breakpoint.smAndUp ? '' : 'Status'">
              </c-select>
            </v-col>
            <v-col
              cols="12"
              sm="2"
              :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
            >
              <v-text-field
                hide-details="auto"
                :label="$vuetify.breakpoint.smAndUp ? '' : 'Date'"
                v-model="situation.changeDateClaimProcedure"
                dense
                outlined
                readonly
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              :class="$vuetify.breakpoint.smAndUp ? 'pl-1' : 'pb-2'"
            >
              <v-text-field
                hide-details="auto"
                :label="$vuetify.breakpoint.smAndUp ? '' : 'Remark'"
                v-model="situation.claimProcedureRemark"
                outlined
                dense
                :readonly="readonly"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- Distribution list (WI-0280) -->
          <v-row no-gutters class="mt-2">
            <v-col
              cols="12"
              sm="2"
              :class="
                $vuetify.breakpoint.smAndUp
                  ? 'd-flex align-center pr-1'
                  : 'pb-2'
              "
            >
              Distribution list (WI-0280)
            </v-col>
            <v-col
              cols="12"
              sm="2"
              :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
            >
              <c-select v-model="situation.distributionList" :readonly="readonly" 
                  :items="statusses" :background-color="background(situation.distributionList)" 
                  :label="$vuetify.breakpoint.smAndUp ? '' : 'Status'">
              </c-select>
            </v-col>
            <v-col
              cols="12"
              sm="2"
              :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
            >
              <v-text-field
                hide-details="auto"
                :label="$vuetify.breakpoint.smAndUp ? '' : 'Date'"
                v-model="situation.changeDateDistributionList"
                dense
                outlined
                readonly
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              :class="$vuetify.breakpoint.smAndUp ? 'pl-1' : 'pb-2'"
            >
              <v-text-field
                hide-details="auto"
                :label="$vuetify.breakpoint.smAndUp ? '' : 'Remark'"
                v-model="situation.distributionListRemark"
                outlined
                dense
                :readonly="readonly"
                placeholder="The Distribution list should be added to the internal attachments in the tab Internal Documents"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- Execution Followup -->
          <v-row no-gutters class="mt-2">
            <v-col
              cols="12"
              sm="2"
              :class="
                $vuetify.breakpoint.smAndUp
                  ? 'd-flex align-center pr-1'
                  : 'pb-2'
              "
            >
              Execution Followup
            </v-col>
            <v-col
              cols="12"
              sm="2"
              :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
            >
              <c-select v-model="situation.executionFollowUp" :readonly="readonly" 
                  :items="statusses" :background-color="background(situation.executionFollowUp)" 
                  :label="$vuetify.breakpoint.smAndUp ? '' : 'Status'">
              </c-select>
            </v-col>
            <v-col
              cols="12"
              sm="2"
              :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
            >
              <v-text-field
                hide-details="auto"
                :label="$vuetify.breakpoint.smAndUp ? '' : 'Date'"
                v-model="situation.changeDateExecutionFollowUp"
                dense
                outlined
                readonly
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              :class="$vuetify.breakpoint.smAndUp ? 'pl-1' : 'pb-2'"
            >
              <v-text-field
                hide-details="auto"
                :label="$vuetify.breakpoint.smAndUp ? '' : 'Remark'"
                v-model="situation.executionFollowUpRemark"
                outlined
                dense
                :readonly="readonly"
                placeholder="For Service Grade A and S make list per distributor of supplied units (use SAP ZMM422). This data should be uploaded in the tab Execution follow up"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- Save electronic copy -->
          <v-row no-gutters class="mt-2">
            <v-col
              cols="12"
              sm="2"
              :class="
                $vuetify.breakpoint.smAndUp
                  ? 'd-flex align-center pr-1'
                  : 'pb-2'
              "
            >
              Save electronic copy
            </v-col>
            <v-col
              cols="12"
              sm="2"
              :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
            >
              <c-select v-model="situation.saveElectronicCopy" :readonly="readonly" 
                  :items="statusses" :background-color="background(situation.saveElectronicCopy)" 
                  :label="$vuetify.breakpoint.smAndUp ? '' : 'Status'">
              </c-select>
            </v-col>
            <v-col
              cols="12"
              sm="2"
              :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
            >
              <v-text-field
                hide-details="auto"
                :label="$vuetify.breakpoint.smAndUp ? '' : 'Date'"
                v-model="situation.changeDateSaveElectronicCopy"
                dense
                outlined
                readonly
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              :class="$vuetify.breakpoint.smAndUp ? 'pl-1' : 'pb-2'"
            >
              <v-text-field
                hide-details="auto"
                :label="$vuetify.breakpoint.smAndUp ? '' : 'Remark'"
                v-model="situation.saveElectronicCopyRemark"
                outlined
                dense
                :readonly="readonly"
                placeholder="Save electronic copy on N:\CLAIM\ESV & adjust the file names"
              ></v-text-field>
            </v-col>
          </v-row>

          <div v-if="esv.statusId === 3">
            <v-row class="ma-0 mt-2">
              <v-col cols="1" class="d-flex align-center">
                <v-divider></v-divider>
              </v-col>
              <v-col class="d-flex align-center">
                <h3 class="pr-6">Distribution steps</h3>
                <v-divider></v-divider>
              </v-col>
            </v-row>

            <!-- Check if SV is saved -->
            <v-row no-gutters class="mt-2">
              <v-col
                cols="12"
                sm="2"
                :class="
                  $vuetify.breakpoint.smAndUp
                    ? 'd-flex align-center pr-1'
                    : 'pb-2'
                "
              >
                Check if SV is saved
              </v-col>
              <v-col
                cols="12"
                sm="2"
                :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
              >
                <c-select v-model="situation.checkIfSvIsSaved" :readonly="readonly" 
                  :items="statusses" :background-color="background(situation.checkIfSvIsSaved)" 
                  :label="$vuetify.breakpoint.smAndUp ? '' : 'Status'">
                </c-select>
                <!-- <v-autocomplete v-if="!readonly"
                  hide-details="auto"
                  :label="$vuetify.breakpoint.smAndUp ? '' : 'Status'"
                  v-model="situation.checkIfSvIsSaved"
                  :background-color="background(situation.checkIfSvSaved)"
                  :items="statusses"
                  outlined
                  dense
                ></v-autocomplete>
                <v-text-field v-else
                  :value="situation.checkIfSvIsSaved"
                  hide-details="auto"
                  outlined dense
                  readonly
                  :background-color="background(situation.checkIfSvIsSaved)"
                >
                </v-text-field> -->
              </v-col>
              <v-col
                cols="12"
                sm="2"
                :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
              >
                <v-text-field
                  hide-details="auto"
                  :label="$vuetify.breakpoint.smAndUp ? '' : 'Date'"
                  v-model="situation.changeDateCheckIfSvIsSaved"
                  dense
                  outlined
                  readonly
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                :class="$vuetify.breakpoint.smAndUp ? 'pl-1' : 'pb-2'"
              >
                <v-text-field
                  hide-details="auto"
                  :label="$vuetify.breakpoint.smAndUp ? '' : 'Remark'"
                  v-model="situation.checkIfSvIsSavedRemark"
                  outlined
                  dense
                  :readonly="readonly"
                  placeholder="SV file location : N:\CLAIM\ESV\SV for import models"
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- Input ESV data in CRP (WI-0492-04) -->
            <v-row no-gutters class="mt-2">
              <v-col
                cols="12"
                sm="2"
                :class="
                  $vuetify.breakpoint.smAndUp
                    ? 'd-flex align-center pr-1'
                    : 'pb-2'
                "
              >
                Input ESV data in CRP (WI-0492-04)
              </v-col>
              <v-col
                cols="12"
                sm="2"
                :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
              >
                <c-select v-model="situation.inputEsvDataInCrp" :readonly="readonly" 
                  :items="statusses" :background-color="background(situation.inputEsvDataInCrp)" 
                  :label="$vuetify.breakpoint.smAndUp ? '' : 'Status'">
                </c-select>
                <!-- <v-autocomplete v-if="!readonly"
                  hide-details="auto"
                  :label="$vuetify.breakpoint.smAndUp ? '' : 'Status'"
                  v-model="situation.inputEsvDataInCrp"
                  :background-color="background(situation.inputEsvDataInCrp)"
                  :items="statusses"
                  outlined
                  dense
                ></v-autocomplete>
                <v-text-field v-else
                  :value="situation.inputEsvDataInCrp"
                  hide-details="auto"
                  outlined dense
                  readonly
                  :background-color="background(situation.inputEsvDataInCrp)"
                >
                </v-text-field> -->
              </v-col>
              <v-col
                cols="12"
                sm="2"
                :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
              >
                <v-text-field
                  hide-details="auto"
                  :label="$vuetify.breakpoint.smAndUp ? '' : 'Date'"
                  v-model="situation.changeDateInputEsvDataInCrp"
                  dense
                  outlined
                  readonly
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                :class="$vuetify.breakpoint.smAndUp ? 'pl-1' : 'pb-2'"
              >
                <v-text-field
                  hide-details="auto"
                  :label="$vuetify.breakpoint.smAndUp ? '' : 'Remark'"
                  v-model="situation.inputEsvDataInCrpRemark"
                  outlined
                  dense
                  :readonly="readonly"
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- Check if files are saved -->
            <v-row no-gutters class="mt-2">
              <v-col
                cols="12"
                sm="2"
                :class="
                  $vuetify.breakpoint.smAndUp
                    ? 'd-flex align-center pr-1'
                    : 'pb-2'
                "
              >
                Check if files are saved
              </v-col>
              <v-col
                cols="12"
                sm="2"
                :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
              >
                <c-select v-model="situation.checkIfFilesAreSaved" :readonly="readonly" 
                  :items="statusses" :background-color="background(situation.checkIfFilesAreSaved)" 
                  :label="$vuetify.breakpoint.smAndUp ? '' : 'Status'">
                </c-select>
                <!-- <v-autocomplete v-if="!readonly"
                  hide-details="auto"
                  :label="$vuetify.breakpoint.smAndUp ? '' : 'Status'"
                  v-model="situation.checkIfFilesAreSaved"
                  :background-color="background(situation.checkIfFilesAreSaved)"
                  :items="statusses"
                  outlined
                  dense
                ></v-autocomplete>
                <v-text-field v-else
                  :value="situation.checkIfFilesAreSaved"
                  hide-details="auto"
                  outlined dense
                  readonly
                  :background-color="background(situation.checkIfFilesAreSaved)"
                >
                </v-text-field> -->
              </v-col>
              <v-col
                cols="12"
                sm="2"
                :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
              >
                <v-text-field
                  hide-details="auto"
                  :label="$vuetify.breakpoint.smAndUp ? '' : 'Date'"
                  v-model="situation.changeDateCheckIfFilesAreSaved"
                  dense
                  outlined
                  readonly
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                :class="$vuetify.breakpoint.smAndUp ? 'pl-1' : 'pb-2'"
              >
                <v-text-field
                  hide-details="auto"
                  :label="$vuetify.breakpoint.smAndUp ? '' : 'Remark'"
                  v-model="situation.checkIfFilesAreSavedRemark"
                  outlined
                  dense
                  :readonly="readonly"
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- Update reinvoicing letter Generator -->
            <v-row no-gutters class="mt-2">
              <v-col
                cols="12"
                sm="2"
                :class="
                  $vuetify.breakpoint.smAndUp
                    ? 'd-flex align-center pr-1'
                    : 'pb-2'
                "
              >
                Update reinvoicing letter Generator
              </v-col>
              <v-col
                cols="12"
                sm="2"
                :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
              >
                <c-select v-model="situation.updateReinvoicingLetterGenerator" :readonly="readonly" 
                  :items="statusses" :background-color="background(situation.updateReinvoicingLetterGenerator)" 
                  :label="$vuetify.breakpoint.smAndUp ? '' : 'Status'">
                </c-select>
                <!-- <v-autocomplete v-if="!readonly"
                  hide-details="auto"
                  :label="$vuetify.breakpoint.smAndUp ? '' : 'Status'"
                  v-model="situation.updateReinvoicingLetterGenerator"
                  :background-color="
                    background(situation.updateReinvoicingLetterGenerator)
                  "
                  :items="statusses"
                  outlined
                  dense
                ></v-autocomplete>
                <v-text-field v-else
                  :value="situation.updateReinvoicingLetterGenerator"
                  hide-details="auto"
                  outlined dense
                  readonly
                  :background-color="background(situation.updateReinvoicingLetterGenerator)"
                >
                </v-text-field> -->
              </v-col>
              <v-col
                cols="12"
                sm="2"
                :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
              >
                <v-text-field
                  hide-details="auto"
                  :label="$vuetify.breakpoint.smAndUp ? '' : 'Date'"
                  v-model="situation.changeDateUpdateReinvoicingLetterGenerator"
                  dense
                  outlined
                  readonly
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                :class="$vuetify.breakpoint.smAndUp ? 'pl-1' : 'pb-2'"
              >
                <v-text-field
                  hide-details="auto"
                  :label="$vuetify.breakpoint.smAndUp ? '' : 'Remark'"
                  v-model="situation.updateReinvoicingLetterGeneratorRemark"
                  outlined
                  dense
                  :readonly="readonly"
                  placeholder="File location : x:\Technical Services Department\21. Warranty (ECHC) & ESV\02 - Budget\Reinvoicing Letter Generator.xls"
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- Add part numbers to ESV follow up -->
            <v-row no-gutters class="mt-2">
              <v-col
                cols="12"
                sm="2"
                :class="
                  $vuetify.breakpoint.smAndUp
                    ? 'd-flex align-center pr-1'
                    : 'pb-2'
                "
              >
                Add part numbers to ESV follow up
              </v-col>
              <v-col
                cols="12"
                sm="2"
                :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
              >
                <c-select v-model="situation.addPartNumbers" :readonly="readonly" :items="statusses" :background-color="background(situation.addPartNumbers)" :label="$vuetify.breakpoint.smAndUp ? '' : 'Status'"></c-select>
                <!-- <v-autocomplete v-if="!readonly"
                  hide-details="auto"
                  :label="$vuetify.breakpoint.smAndUp ? '' : 'Status'"
                  v-model="situation.addPartNumbers"
                  :background-color="background(situation.addPartNumbers)"
                  :items="statusses"
                  outlined
                  dense
                ></v-autocomplete>
                <v-text-field v-else
                  :value="situation.addPartNumbers"
                  hide-details="auto"
                  outlined dense
                  readonly
                  :background-color="background(situation.addPartNumbers)"
                >
                </v-text-field> -->
              </v-col>
              <v-col
                cols="12"
                sm="2"
                :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
              >
                <v-text-field
                  :label="$vuetify.breakpoint.smAndUp ? '' : 'Date'"
                  hide-details="auto"
                  v-model="situation.changeDateAddPartNumbers"
                  dense
                  outlined
                  readonly
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                :class="$vuetify.breakpoint.smAndUp ? 'pl-1' : 'pb-2'"
              >
                <v-text-field
                  hide-details="auto"
                  :label="$vuetify.breakpoint.smAndUp ? '' : 'Remark'"
                  v-model="situation.addPartNumbersRemark"
                  outlined
                  dense
                  :readonly="readonly"
                  placeholder="ESV follow up file location: X:\Spare parts planning\21 Planning\ESV Follow Up V2.xlsx"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>

          
          <!-- </v-container> -->
        </v-card-text>
      </v-card>
    </v-card>
    <div style="height: 150px;"></div>
    <tab-footer
      v-if="!readonly"
      :esv="esv"
      :loading="loading"
      action="ESVSituation"
      @save="save"
      @start-approval="save(true)"
      @cancel="$emit('edit')"
    >
    </tab-footer>

    <approve-reject
      :esvId="esvId"
      v-if="readonly && $can('Approve', esv)"
    ></approve-reject>
    <publish-footer :esv="esv"></publish-footer>
  </div>
</template>

<script>
// @ is an alias to /src
import common, { background } from "@/services/Common";
import TabHeader from "./TabHeader.vue";
import TabFooter from "./TabFooter.vue";
import {DocumentFields} from "@/enums/DocumentFields";
import unsavedChangesWarningMixin from '@/mixins/unsavedChangesWarningMixin';
// import CSelect from '@/components/common/CSelect.vue';

export default {
  name: "ESVSituation",
  mixins: [unsavedChangesWarningMixin],
  computed: {
    DocumentFields() {
      return DocumentFields
    }
  },
  components: {
    DatePicker: () => import("@/components/common/DatePicker.vue"),
    TabHeader,
    TabFooter,
    ApproveReject: () => import("@/components/ESV/ApproveReject.vue"),
    PublishFooter: () => import("@/components/ESV/PublishFooter.vue"),
    // CSelect
  },
  props: {
    esvId: Number,
    readonly: {
      type: Boolean,
      default: true,
    },
    lockLoading: Boolean,
    saveCounter: Number,
    tabChangeSaveCounter: Number,
    reloadCounter: Number,
    isConfirmingTabChange: Boolean
  },
  data() {
    return {
      esv: {},
      situation: {},
      loading: false,
      statusses: [
        {
          text: "Plan",
          value: "Plan",
          icon: "mdi-notebook-outline",
          color: "yellow",
        },
        {
          text: "Busy",
          value: "Busy",
          icon: "mdi-notebook-outline",
          color: "yellow",
        },
        {
          text: "Final",
          value: "Final",
          icon: "mdi-notebook-outline",
          color: "yellow",
        },
        { text: "-", value: "-" },
      ],
      topics: ["New", "Update"],
      peopleInCharge: [],
      lastSaveSource: null, // Track source of last save
    };
  },
  methods: {
    getEsv() {
      this.$api
        .getEsvMinimal(this.esvId)
        .then((resp) => (this.esv = resp.data));
    },
    getSituation() {
      this.$api
        .getEsvSituation(this.esvId)
        .then((resp) => (this.situation = resp.data));
    },
    getPeopleInCharge() {
      this.$api
        .getUsersForDropDown()
        .then((resp) => (this.peopleInCharge = resp.data));
    },

    save(startApproval) {
      this.$api
        .updateEsvSituation(this.situation)
        .then(() => {
          this.$toast.success("Changes have been saved");
          if (startApproval) {
            this.$router.push({
              name: "ApprovalValidation",
              params: { esvId: this.id },
            });
          }
          else {
            this.getSituation();
            console.log('ESVSituation.vue: Emitting save-successful...');
            if (this.lastSaveSource === 'tab-change') {
              this.$emit('save-successful-tab-change');
            } else {
              this.$emit('save-successful');
            }
            this.lastSaveSource = null; // Reset after use
          }
        })
        .catch(error => {
           console.error('ESVSituation.vue: API updateEsvSituation failed:', error);
        });
    },

    background(status) {
      return background(status);
    },

    routeBackToList() {
      if (!this.readonly){
        this.$emit('edit');
      }
      this.$router.go(-1);
    },

    isFieldVisible(fieldName) {
      return common.isFieldVisible(this.$store, this.esv, fieldName);
    }
  },
  created() {
    this.getEsv();
    this.getSituation();
    this.getPeopleInCharge();
  },
  watch: {
    // readonly: {
    //   handler() {
    //     if (this.readonly) {
    //       this.getSituation();
    //     }
    //   },
    // },
    saveCounter: {
      handler() {
        this.lastSaveSource = 'manual';
        this.save();
      }
    },
    tabChangeSaveCounter: {
      handler() {
        this.lastSaveSource = 'tab-change';
        this.save();
      }
    },
    reloadCounter: {
      handler() {
        console.log('reload situation');
        this.getSituation();
      },
    },
  },
};
</script>